import React from 'react'
import { useSelector } from 'react-redux'
import TicketsCounterManager from 'components/TicketsCounterManager'
import SidebarNav from 'components/SidebarNav'
import TicketsPanel from 'components/TicketsPanel'

const Panels = () => {
  const { auth } = useSelector(({ auth }) => auth)

  return (
    <div>
      {auth && (
        <>
          <TicketsCounterManager />
          <SidebarNav />
          <TicketsPanel />
        </>
      )}
    </div>
  )
}

export default Panels
